import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import './ServiceTabSlider.scss';
import service1 from "../../assets/category/service-1.jpg";
import service2 from "../../assets/category/service-2.jpg";
import service3 from "../../assets/category/service-3.jpg";
import service4 from "../../assets/category/service-4.jpg";

import service5 from "../../assets/category/service-5.jpg";
import service6 from "../../assets/category/service-6.jpg";
import service7 from "../../assets/category/service-7.jpg";
import service8 from "../../assets/category/service-8.jpg";



const tabData = {
  Adventure:[
    {
      image: service1,
      title: 'The Grand Machal - ATV',
      content: 'The Grand Machal Adventure',
      button: 'Explore More',
    },
    {
      image: service5,
      title: 'The Grand Machal- Bungee Trampoline',
      content: 'The Grand Machal Adventure',
      button: 'Explore More',
    },
  ],
  Accomodation:[
    {
      image: service2,
      title: 'The Grand Machal- Urban Room',
      content: 'The Grand Machal Accomodation',
      button: 'Book Now',
    },
    {
      image:service6,
      title: 'The Grand Machal- Urban Cottages',
      content: 'The Grand Machal Accomodation',
      button: 'Book Now',
    },
    ],
    Restaurent:[
    {
      image: service3,
      title: 'The Grand Machal- Food Restaurent',
      content: 'The Grand Machal Restaurent',
      button: 'Book Now',
    },
    {
      image:service7,
      title: 'The Grand Machal- Restaurent',
      content: 'The Grand Machal Restaurent',
      button: 'Book Now',
    },

  ],
  Wedding :[
    {
      image: service4,
      title: 'The Grand Machal - Wedding',
      content: 'The Grand Machal Wedding',
      button: 'Book Now',
    },
    {
      image:service8,
      title: 'The Grand Machal  Events',
      content: 'The Grand Machal Wedding',
      button: 'Book Now',
    },

  ],
};

function ServiceTabSlider() {
  const [activeTab, setActiveTab] = useState('Adventure');

  return (
    <div className="app" style={{marginTop:'10px'}}>
      <div className="tabs">
        {Object.keys(tabData).map((tab) => (
          <button
            key={tab}
            className={activeTab === tab ? 'active' : ''}
            onClick={() => setActiveTab(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      <div className="slider-container">
        <Swiper modules={[Navigation]} navigation={{
          nextEl:'custom-next',
          prevEl:'custom-prev',
        }} spaceBetween={10} slidesPerView={2}  autoplay={{ delay: 2000, disableOnInteraction: false }}
  loop={true}
  >
          {tabData[activeTab].map((slide, index) => (
            <SwiperSlide key={index}>
              <div className="slide-content">
                <img src={slide.image} alt={slide.title} />
                <h3>{slide.title}</h3>
                <p>{slide.content}</p>
                <button>{slide.button}</button>
              </div>
            </SwiperSlide>
            
          ))}
          
        </Swiper>
      </div>
    </div>
  );
}

export default ServiceTabSlider;